import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { ACTIONS, CATEGORIES } from "./types";

type Props = {
  category: string; setCategory: (v: string) => void;
  action: string; setAction: (v: string) => void;
  batchId: string; setBatchId: (v: string) => void;
  adminUserId: string; setAdminUserId: (v: string) => void;
  targetUserId: string; setTargetUserId: (v: string) => void;
  fromDate: string; setFromDate: (v: string) => void;
  toDate: string; setToDate: (v: string) => void;
};

export const CreditAuditFilters = ({
  category, setCategory, action, setAction, batchId, setBatchId,
  adminUserId, setAdminUserId, targetUserId, setTargetUserId,
  fromDate, setFromDate, toDate, setToDate,
}: Props) => (
  <div className="grid gap-3 md:grid-cols-3">
    <div>
      <Label htmlFor="ca-category">Category</Label>
      <Select value={category} onValueChange={setCategory}>
        <SelectTrigger id="ca-category"><SelectValue /></SelectTrigger>
        <SelectContent>
          {CATEGORIES.map((c) => (
            <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
    <div>
      <Label htmlFor="ca-action">Action</Label>
      <Select value={action} onValueChange={setAction}>
        <SelectTrigger id="ca-action"><SelectValue /></SelectTrigger>
        <SelectContent>
          {ACTIONS.map((a) => (
            <SelectItem key={a.value} value={a.value}>{a.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
    <div>
      <Label htmlFor="ca-batch">Batch ID</Label>
      <Input
        id="ca-batch" value={batchId} onChange={(e) => setBatchId(e.target.value)}
        placeholder="UUID" className="font-mono"
      />
    </div>
    <div>
      <Label htmlFor="ca-admin">Admin user ID</Label>
      <Input
        id="ca-admin" value={adminUserId} onChange={(e) => setAdminUserId(e.target.value)}
        placeholder="UUID" className="font-mono"
      />
    </div>
    <div>
      <Label htmlFor="ca-target">Target user ID</Label>
      <Input
        id="ca-target" value={targetUserId} onChange={(e) => setTargetUserId(e.target.value)}
        placeholder="UUID" className="font-mono"
      />
    </div>
    <div className="grid grid-cols-2 gap-2">
      <div>
        <Label htmlFor="ca-from">From</Label>
        <Input id="ca-from" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
      </div>
      <div>
        <Label htmlFor="ca-to">To</Label>
        <Input id="ca-to" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
      </div>
    </div>
  </div>
);
